import { useState } from 'react';

import { Button } from 'components/Button';
import { Tooltip, TooltipContent, TooltipTrigger } from 'components/Tooltip';
import { Input } from 'components/input';
import { Grid } from 'components/layout';
import { Flex } from 'components/layout';
import ButtonLoader from 'components/loading/ButtonLoader';
import DATLogo from 'icons/DAT';
import InfoCircleIcon from 'icons/InfoCircle';
import { Maybe } from 'types/UtilityTypes';
import ButtonText from 'types/enums/ButtonText';
import { ButtonNamePosthog } from 'types/enums/CustomPosthogEvents';

import { enableDATAccess } from '../utils';

interface DATAccessSectionProps {
  serviceUsesDAT: boolean;
  hasGrantedDATPermissions: Maybe<boolean>;
  isLoadingDAT: boolean;
  setIsLoadingDAT: (loading: boolean) => void;
  setHasGrantedDATPermissions: React.Dispatch<
    React.SetStateAction<Maybe<boolean>>
  >;
}

export const DATAccessSection = ({
  serviceUsesDAT,
  hasGrantedDATPermissions,
  isLoadingDAT,
  setIsLoadingDAT,
  setHasGrantedDATPermissions,
}: DATAccessSectionProps) => {
  const [datEmailAddress, setDATEmailAddress] = useState<string>('');

  const handleEnableDATAccess = async () => {
    setIsLoadingDAT(true);

    await enableDATAccess({
      datEmailAddress,
      setHasGrantedDATPermissions,
    });

    setIsLoadingDAT(false);
  };

  if (
    !serviceUsesDAT ||
    hasGrantedDATPermissions === null ||
    hasGrantedDATPermissions
  ) {
    return null;
  }

  return (
    <Grid
      gap='md'
      className='w-full mx-0 bg-info-200 border border-info-main rounded-[4px] py-4 px-3'
    >
      <Flex align='center' justify='between'>
        <DATLogo height={12} />
        <Tooltip delayDuration={10}>
          <TooltipTrigger>
            <InfoCircleIcon className='w-5 h-5 text-info-main cursor-pointer' />
          </TooltipTrigger>
          <TooltipContent>Enable DAT using your email address</TooltipContent>
        </Tooltip>
      </Flex>

      <Flex justify='between' align='end' gap='md' className='w-full'>
        <Flex direction='col' className='w-full grow'>
          <label className='text-sm text-neutral-800 mb-1'>Email Address</label>
          <Input
            name='datEmailAddress'
            placeholder='dat_user@example.com'
            className='outline-none!'
            onChange={(e) => setDATEmailAddress(e.target.value)}
          />
        </Flex>

        <Button
          buttonNamePosthog={ButtonNamePosthog.EnableDATForUser}
          className='w-20 h-8 text-sm mb-px bg-brand-main/80'
          onClick={handleEnableDATAccess}
          disabled={isLoadingDAT || !datEmailAddress}
          type='button'
        >
          {isLoadingDAT ? <ButtonLoader /> : ButtonText.EnableDATForUser}
        </Button>
      </Flex>
    </Grid>
  );
};
